<template>
    <div id="app">
        <v-app>
            <v-main class="login">
                <router-view></router-view>
                <snackbar
                    :color="snackbar_color"
                    :data="snackbar_data"
                    :display="snackbar"
                    @closed="snackbar = false"
                />
            </v-main>
        </v-app>
    </div>
</template>

<script>
import EventBus, {ACTIONS} from './event-bus';
import Snackbar from "./components/Snackbar";

export default {
    name: 'App',
    components: {
        Snackbar
    },
    data() {
        return {
            snackbar: false,
            snackbar_color: null,
            snackbar_data: []
        };
    },
    mounted() {
        EventBus.$on(ACTIONS.SNACKBAR, (data, color) => {
            this.snackbar = true;
            this.snackbar_color = color;
            this.snackbar_data = data;
        });
    },
};
</script>
